/*
 * Filename: invoke-action-rule.controller.ts
 * Description: Controller for invoke action rule
 */

import { CQAppConstant } from '../../../app-constants'; 
import { ICriteria } from '../../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { FormRuleController } from '../form-rule.controller';

interface IInvokeRuleObject{
    action:[{
        name:string;
        ns:string;
    }]
    fields:string[];
    filter:string;
}

interface IInvokeRuleModalState {
    actions:[{
        name:string;
        ns:string;
    }]
    addedCriterias: ICriteria[];
    autoLaunchFlowList: any[];
    complexLogicQuery: string;
    complexLogicVisibility : boolean;
    additionalFields:string[];
    fieldWisePicklistValues:any[];
    selectedReferenceFields:any[];
    shouldSkip: boolean
}

export class CQInvokeActionRuleController extends FormRuleController {
    public ruleJSON: any = {};

    constructor(ruleObject: IInvokeRuleModalState) {
        super();
        this.formRuleJson(ruleObject);
    }

    /**
     * @private
     * @memberof CQInvokeActionRuleController
     */
    private formRuleJson = (invokeActionRuleData: IInvokeRuleModalState) => {
        
        const invokeActionRule: IInvokeRuleObject = this.formRuleFilter(invokeActionRuleData);

        this.ruleJSON = {
            'invoke': invokeActionRule
        };

        return this.formRuleJson;
    }

    /**
    * @memberof CQInvokeActionRuleController
    */
    public formRuleFilter = (invokeActionRuleData: IInvokeRuleModalState) => {
        
        const fields: string[] = [];

        const invokeRuleObject = { fields, filter: '', action: invokeActionRuleData.actions };
        invokeActionRuleData.addedCriterias.forEach((criteria: ICriteria) => {
            const fieldName = criteria.field.split('-')[0];
            if(!invokeRuleObject.fields.includes(fieldName)){
                invokeRuleObject.fields.push(fieldName);
            }
            
            if (criteria.isDynamic && criteria.operator !== CQAppConstant.EXISTS
                && criteria.operator !== CQAppConstant.ISEMPTY) {
                const fieldName = criteria.compareTo.split('-')[0];
                if(!invokeRuleObject.fields.includes(fieldName)){
                    invokeRuleObject.fields.push(fieldName);
                }
            }
        });

        if(invokeActionRuleData.shouldSkip){
            invokeRuleObject.filter = "true";
        }else{
            invokeRuleObject.filter = this.formFilterString(invokeActionRuleData.complexLogicQuery, invokeActionRuleData.addedCriterias);
        }
        return invokeRuleObject;
    }
}

